// import React, { useState } from 'react';
// import './Student_Form.css';
// const Student_Form = () => {
//   const [studySituation, setStudySituation] = useState('');
//   const [hasStudyPermit, setHasStudyPermit] = useState(null);
//   const [hasApplications, setHasApplications] = useState(null);
//   const [hasRecruitmentPartner, setHasRecruitmentPartner] = useState(null);
//   const [hasLetterOfAcceptance, setHasLetterOfAcceptance] = useState(null);
//   const handleSituationClick = (situation) => {
//     setStudySituation(situation);
//   };
//   const handleStudyPermitClick = (hasPermit) => {
//     setHasStudyPermit(hasPermit);
//   };
//   const handleApplicationsClick = (hasApps) => {
//     setHasApplications(hasApps);
//   };
//   const handleRecruitmentPartnerClick = (hasPartner) => {
//     setHasRecruitmentPartner(hasPartner);
//   };
//   const handleLetterOfAcceptanceClick = (hasLetter) => {
//     setHasLetterOfAcceptance(hasLetter);
//   };
//   const [selectedProvinces, setSelectedProvinces] = useState([]);
//   const handleProvinceChange = (e) => {
//     const { value, checked } = e.target;
//     if (checked) {
//       setSelectedProvinces([...selectedProvinces, value]);
//     } else {
//       setSelectedProvinces(selectedProvinces.filter((province) => province !== value));
//     }
//   };
//   const [selectedGradingSystem, setSelectedGradingSystem] = useState('');
//   const [gpa, setGpa] = useState('');
//  const handleGradingSystemChange = (e) => {
//     setSelectedGradingSystem(e.target.value);
//     setGpa(''); 
//   };
//   const handleGpaChange = (e) => {
//     setGpa(e.target.value);
//   };
//   return (
//     <div className="form-container">
//       <form className="student-form">
//         <div className="personal-profile">
//           <h2 className="heading_sub">Personal Profile</h2>
//           <div className='two_div'>
//             <div className="form-group">
//               <label>What is your current situation?*</label>
//               <div className="button-group">
//                 <button
//                   type="button"
//                   className="main_selection_btn"
//                   onClick={() => handleSituationClick('study')}
//                 >
//                   I want to study in Canada
//                 </button>
//                 <button
//                   type="button"
//                   className="main_selection_btn"
//                   onClick={() => handleSituationClick('studying')}
//                 >
//                   I am currently studying in Canada
//                 </button>
//               </div>
//             </div>
//             <div className="form-group">
//               <label>What is your preferred language of communication?*</label>
//               <div className="button-group">
//                 <button className="yes_no_btn" type="button">English</button>
//                 <button className="yes_no_btn" type="button">French</button>
//               </div>
//             </div>
//           </div>
//           <div className="two_div">
//             <div className="form-group">
//               <label>Are you interested in obtaining permanent residence in Canada?*</label>
//               <div className="button-group">
//                 <button className="yes_no_btn" type="button">Yes</button>
//                 <button className="yes_no_btn" type="button">No</button>
//               </div>
//             </div>
//             <div className="form-group">
//               <label>Age</label>
//               <select>
//                 <option>Select your age</option>
//               </select>
//             </div>
//           </div>
//           {studySituation === 'study' && (
//             <>
//               <div className="form-section">
//                 <h2 className="heading_sub">Canadian Studies</h2>
//                 <div className="form-group">
//                   <label>Do you have any applications in progress with a Canadian School?</label>
//                   <div className="button-group">
//                     <button 
//                       className="yes_no_btn button_clr" 
//                       type="button"
//                       onClick={() => handleApplicationsClick(true)}
//                     >
//                       Yes
//                     </button>
//                     <button 
//                       className="yes_no_btn button_clr" 
//                       type="button"
//                       onClick={() => handleApplicationsClick(false)}
//                     >
//                       No
//                     </button>
//                   </div>
//                 </div>
//                 {hasApplications === true && (
//                   <div className="form-group">
//                     <label>With which schools?</label>
//                     <input 
//                       type="text" 
//                       placeholder="Enter the school name"
//                     />
//                   </div>
//                 )}
//                 <div className="form-group">
//                   <label>Are you working with an existing Recruitment Partner/Agent/Counsellor/Education Consultant?</label>
//                   <div className="button-group">
//                     <button 
//                       className="yes_no_btn button_clr" 
//                       type="button"
//                       onClick={() => handleRecruitmentPartnerClick(true)}
//                     >
//                       Yes
//                     </button>
//                     <button 
//                       className="yes_no_btn button_clr" 
//                       type="button"
//                       onClick={() => handleRecruitmentPartnerClick(false)}
//                     >
//                       No
//                     </button>
//                   </div>
//                 </div>
//                 {hasRecruitmentPartner === true && (
//                   <div className="form-group">
//                     <label>Who?</label>
//                     <input 
//                       type="text" 
//                       placeholder="Enter the name"
//                     />
//                   </div>
//                 )}
//                 <div className="form-group">
//                   <label>Do you have a Letter of Acceptance?*</label>
//                   <div className="button-group">
//                     <button 
//                       className="yes_no_btn button_clr" 
//                       type="button"
//                       onClick={() => handleLetterOfAcceptanceClick(true)}
//                     >
//                       Yes
//                     </button>
//                     <button 
//                       className="yes_no_btn button_clr" 
//                       type="button"
//                       onClick={() => handleLetterOfAcceptanceClick(false)}
//                     >
//                       No
//                     </button>
//                   </div>
//                 </div>
//                 {hasLetterOfAcceptance === true && (
//                   <div className="form-group">
//                     <label>In which Canadian province or territory is the school you will be attending?</label>
//                     <select>
//                       <option value="">Select Province</option>
//                       <option value="ON">Ontario</option>
//                       <option value="BC">British Columbia</option>
//                       <option value="AB">Alberta</option>
//                     </select>
//                   </div>
//                 )}
// {hasLetterOfAcceptance === false && (
//         <div className="education-form">
//            <div className="section">
//              <label>Which provinces do you prefer to study in?</label>
//              <div className="checkbox-group">
//                {["Any Province", "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon"].map((province) => (
//                  <label key={province}>
//                    <input
//                      type="checkbox"
//                      value={province}
//                      checked={selectedProvinces.includes(province)}
//                      onChange={handleProvinceChange}
//                    />
//                    {province}
//                  </label>
//                ))}
//              </div>
//            </div>
//            <div className="section">
//              <label>What fields of study are you interested in?</label>
//              <select>
//                <option value="">Please select</option>
//                <option value="Engineering">Engineering</option>
//                <option value="Medicine">Medicine</option>
//                <option value="Business">Business</option>
//              </select>
//            </div>
//            <div className="section">
//              <label>What program level are you interested in?</label>
//              <select>
//                <option value="">Please select</option>
//                <option value="Undergraduate">Undergraduate</option>
//                <option value="Graduate">Graduate</option>
//              </select>
//            </div>
//            <div className="section">
//              <h3>Your Current Education</h3>
//              <label>What is your highest level of completed education?</label>
//              <select>
//                <option value="">Please select</option>
//                <option value="High School">High School</option>
//                <option value="Bachelor's Degree">Bachelor's Degree</option>
//              </select>
//              <label>When was your last level of education completed?</label>
//              <div className="date-select">
//                <select>
//                  <option value="">Month</option>
//                  {/* Add month options */}
//                </select>
//                <select>
//                  <option value="">Year</option>
//                  {/* Add year options */}
//                </select>
//              </div>
//              <label>In which country was this level of education obtained?</label>
//              <select>
//                <option value="">Select country</option>
//                {/* Add country options */}
//              </select>
//              <label>Do you have official transcripts from your highest level of completed education?</label>
//              <div className="radio-group">
//                <label>
//                  <input type="radio" name="transcripts" value="yes" /> Yes
//                </label>
//                <label>
//                  <input type="radio" name="transcripts" value="no" /> No
//                </label>
//              </div>
//            </div>
//            <div className="grading-system-section">
//                 <label>What was the grading system used by your country?</label>
//                 <select 
//                   value={selectedGradingSystem}
//                   onChange={handleGradingSystemChange}
//                   className="grading-select"
//                 >
//                   <option value="">Please select</option>
//                   <option value="0-100">0-100</option>
//                   <option value="0-20">0-20</option>
//                   <option value="0-10">0-10</option>
//                   <option value="0-5">0-5</option>
//                   <option value="0-4">0-4</option>
//                   <option value="division">Division/Class</option>
//                   <option value="letter">A/A+ to F</option>
//                   <option value="other">Other</option>
//                 </select>
//                 {selectedGradingSystem && (
//                   <div className="gpa-input-section">
//                     <label>GPA</label>
//                     <input
//                       type="text"
//                       value={gpa}
//                       onChange={handleGpaChange}
//                       placeholder="Enter your GPA"
//                       className="gpa-input"
//                     />
//                   </div>
//                 )}
//               </div>
//            <div className="section">
//              <h3>Your language skills</h3>
//              <label>Have you undergone a language proficiency test in English or French?</label>
//              <select>
//                <option value="">Please select</option>
//                <option value="English">English</option>
//                <option value="French">French</option>
//              </select>
//            </div>
//            </div>
//                 )}
//                 <div className="form-group">
//                   <label>When would you like to start your studies in Canada?</label>
//                   <div className="two_div">
//                     <select>
//                       <option>Month</option>
//                     </select>
//                     <select>
//                       <option>Year</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//               <div className="form-section">
//                 <h2 className="heading_sub">Financial Support</h2>
//                 <div className="form-group">
//                   <label>What is your estimated budget for tuition per year?</label>
//                   <select>
//                     <option>Please select</option>
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>
//                     Would you have access to at least CAD $35K to cover your tuition fees and living expenses in Canada during your first year of studies?
//                   </label>
//                   <div className="button-group">
//                     <button className="yes_no_btn" type="button">Yes</button>
//                     <button className="yes_no_btn" type="button">No</button>
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <label>Have you ever been refused a visa to Canada or any other country?</label>
//                   <div className="button-group">
//                     <button className="yes_no_btn" type="button">Yes</button>
//                     <button className="yes_no_btn" type="button">No</button>
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <label>Do you have a spouse or common-law partner?</label>
//                   <div className="button-group">
//                     <button className="yes_no_btn" type="button">Yes</button>
//                     <button className="yes_no_btn" type="button">No</button>
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <label>Do you have any children?</label>
//                   <div className="button-group">
//                     <button className="yes_no_btn" type="button">Yes</button>
//                     <button className="yes_no_btn" type="button">No</button>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//           {studySituation === 'studying' && (
//             <>
//               <div className="form-section">
//                 <h2 className="heading_sub">Current Studies Information</h2>
//                 <div className="form-group">
//                   <label>Do you plan on obtaining a Post-Graduation Work Permit upon completion of your studies in Canada?</label>
//                   <div className="button-group">
//                     <button className="yes_no_btn" type="button">Yes</button>
//                     <button className="yes_no_btn" type="button">No</button>
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <label>After completion of your current study program, do you intend to pursue further studies in Canada?</label>
//                   <div className="button-group">
//                     <button className="yes_no_btn" type="button">Yes</button>
//                     <button className="yes_no_btn" type="button">No</button>
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <label>Do you possess a valid Canadian Study Permit?*</label>
//                   <div className="button-group">
//                     <button 
//                       className="yes_no_btn button_clr" 
//                       type="button"
//                       onClick={() => handleStudyPermitClick(true)}
//                     >
//                       Yes
//                     </button>
//                     <button 
//                       className="yes_no_btn button_clr" 
//                       type="button"
//                       onClick={() => handleStudyPermitClick(false)}
//                     >
//                       No
//                     </button>
//                   </div>
//                 </div>
//                 {hasStudyPermit === true && (
//                   <>
//                     <div className="form-group">
//                       <label>When do you expect to complete your current study program in Canada?</label>
//                       <div className="two_div">
//                         <select>
//                           <option value="" disabled>Month</option>
//                           <option value="01">January</option>
//                           <option value="02">February</option>
//                           <option value="03">March</option>
//                           <option value="04">April</option>
//                           <option value="05">May</option>
//                           <option value="06">June</option>
//                           <option value="07">July</option>
//                           <option value="08">August</option>
//                           <option value="09">September</option>
//                           <option value="10">October</option>
//                           <option value="11">November</option>
//                           <option value="12">December</option>
//                         </select>
//                         <select>
//                           <option value="" disabled>Year</option>
//                           <option value="2024">2024</option>
//                           <option value="2025">2025</option>
//                           <option value="2026">2026</option>
//                           <option value="2027">2027</option>
//                           <option value="2028">2028</option>
//                         </select>
//                       </div>
//                     </div>
//                     <div className="form-group">
//                       <label>In which Canadian province or territory is the school you are currently attending?</label>
//                       <select>
//                         <option value="">Select Province</option>
//                         <option value="AB">Alberta</option>
//                         <option value="BC">British Columbia</option>
//                         <option value="MB">Manitoba</option>
//                         <option value="NB">New Brunswick</option>
//                         <option value="NL">Newfoundland and Labrador</option>
//                         <option value="NS">Nova Scotia</option>
//                         <option value="ON">Ontario</option>
//                         <option value="PE">Prince Edward Island</option>
//                         <option value="QC">Quebec</option>
//                         <option value="SK">Saskatchewan</option>
//                         <option value="NT">Northwest Territories</option>
//                         <option value="NU">Nunavut</option>
//                         <option value="YT">Yukon</option>
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>What is the name of the institution at which you are currently studying?</label>
//                       <input 
//                         type="text" 
//                         placeholder="Enter institution name"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>What is the field of study that you are currently enrolled in?</label>
//                       <input 
//                         type="text" 
//                         placeholder="Enter your field of study"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>What is the level of education you are currently enrolled in (e.g. bachelor/master's/doctoral)?</label>
//                       <select>
//                         <option value="">Please select</option>
//                         <option value="bachelor">Bachelor's Degree</option>
//                         <option value="master">Master's Degree</option>
//                         <option value="doctoral">Doctoral Degree</option>
//                         <option value="diploma">Diploma</option>
//                         <option value="certificate">Certificate</option>
//                       </select>
//                     </div>
//                   </>
//                 )}
//                 {hasStudyPermit === false && (
//                   <div className="form-group">
//                     <label>What is your current status in Canada?</label>
//                     <select>
//                       <option value="">Please select</option>
//                       <option value="work_permit">Work Permit</option>
//                       <option value="visitor">Visitor</option>
//                       <option value="permanent_resident">Permanent Resident</option>
//                       <option value="citizen">Citizen</option>
//                       <option value="out_of_status">Out of Status</option>
//                     </select>
//                   </div>
//                 )}
//               </div>
//             </>
//           )}
//         </div>
//         <div className="contact-information">
//           <h2 className="heading_sub">Enter Your Contact Information</h2>
//           <div className="form-group">
//             <label>Name*</label>
//             <input type="text" placeholder="Enter your name" />
//           </div>
//           <div className="form-group">
//             <label>Country of residence</label>
//             <select>
//               <option>Select country</option>
//             </select>
//           </div>
//           <div className="form-group">
//             <label>Email*</label>
//             <input type="email" placeholder="Enter your email address" />
//           </div>
//           <div className="form-group">
//             <label>Country of citizenship</label>
//             <select>
//               <option>Select country</option>
//             </select>
//           </div>
//           <div className="form-group">
//             <label>Telephone*</label>
//             <input type="tel" placeholder="Enter your phone number, including country code" />
//           </div>
//           <div className="form-group">
//             <input type="checkbox" />
//             <label>Yes, please send me the free Canadian Immigration Newsletter by email.</label>
//           </div>
//           <div className="submit-button">
//             <button type="submit">Submit Form</button>
//           </div>
//         </div>
//         <div className="privacy-notice">
//           <p>The personal information you provide to the Cohen Immigration Law is secure...</p>
//         </div>
//       </form>
//     </div>
//   );
// };
// export default Student_Form;











//////////////////////////////////////////////////////// pseudo ///////////////////////////////////////////////////////////



import React, { useState } from 'react';
import './Student_Form.css';
const Student_Form = () => {
  const [studySituation, setStudySituation] = useState('');
  const [hasStudyPermit, setHasStudyPermit] = useState(null);
  const [hasApplications, setHasApplications] = useState(null);
  const [hasRecruitmentPartner, setHasRecruitmentPartner] = useState(null);
  const [hasLetterOfAcceptance, setHasLetterOfAcceptance] = useState(null);



  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [selectedTest, setSelectedTest] = useState('');
  const [scores, setScores] = useState({
    listening: '',
    speaking: '',
    reading: '',
    writing: ''
  });

  const handleTestChange = (e) => {
    setSelectedTest(e.target.value);
  };


  const handleScoreChange = (type, value) => {
    setScores(prev => ({
      ...prev,
      [type]: value
    }));
  };

  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
    setSelectedTest('');
    setScores({
      listening: '',
      speaking: '',
      reading: '',
      writing: ''
    });
  };



  const handleSituationClick = (situation) => {
    setStudySituation(situation);
  };
  const handleStudyPermitClick = (hasPermit) => {
    setHasStudyPermit(hasPermit);
  };
  const handleApplicationsClick = (hasApps) => {
    setHasApplications(hasApps);
  };
  const handleRecruitmentPartnerClick = (hasPartner) => {
    setHasRecruitmentPartner(hasPartner);
  };
  const handleLetterOfAcceptanceClick = (hasLetter) => {
    setHasLetterOfAcceptance(hasLetter);
  };
  const [selectedProvinces, setSelectedProvinces] = useState([]);
  const handleProvinceChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedProvinces([...selectedProvinces, value]);
    } else {
      setSelectedProvinces(selectedProvinces.filter((province) => province !== value));
    }
  };
  const [selectedGradingSystem, setSelectedGradingSystem] = useState('');
  const [gpa, setGpa] = useState('');
  const handleGradingSystemChange = (e) => {
    setSelectedGradingSystem(e.target.value);
    setGpa('');
  };
  const handleGpaChange = (e) => {
    setGpa(e.target.value);
  };


  // ai form
  const [formData, setFormData] = useState({
    currentSituation: '',
    language: '',
    permanentResidence: '',
    age: '',
    name: '',
    countryOfResidence: '',
    email: '',
    countryOfCitizenship: '',
    telephone: '',
    newsletter: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Form submitted successfully!');
  };

  const styles = `
    .form-container {
      min-height: 100vh;
       background: linear-gradient(135deg, #1a2f1a 0%, #2d4a3e 100%);
      padding: 2rem 1rem;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }

    .form-wrapper {
      max-width: 800px;
      margin: 0 auto;
      padding-top:8rem 
    }

    .form-card {
      background: rgba(255, 255, 255, 0.98);
      border-radius: 24px;
      
      box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
      overflow: hidden;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      transform: translateY(0);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .form-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 40px 80px rgba(0, 0, 0, 0.4);
    }

    .form-header {
      background: linear-gradient(135deg, #F7921E 100%, #198754 0%);
      padding: 2.5rem 2rem;
      text-align: center;
      position: relative;
      overflow: hidden;
    }

    .form-header::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="1" fill="white" opacity="0.1"/><circle cx="10" cy="50" r="1" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    }

    .form-title {
      font-size: 2.5rem;
      font-weight: 800;
      color: white;
      margin: 0 0 0.5rem 0;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
      position: relative;
      z-index: 1;
    }

    .form-subtitle {
      font-size: 1.1rem;
      color: rgba(255, 255, 255, 0.9);
      margin: 0;
      font-weight: 400;
      position: relative;
      z-index: 1;
    }

    .form-content {
      padding: 2.5rem;
    }

    .section-title {
      font-size: 1.8rem;
      font-weight: 700;
      color: #2d3748;
      margin: 0 0 1.5rem 0;
      position: relative;
      padding-bottom: 0.5rem;
    }

    .section-title::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, #F7921E );
      border-radius: 2px;
    }

    .form-group {
      margin-bottom: 2rem;
    }

    .form-label {
      display: block;
      font-size: 1rem;
      font-weight: 600;
      color: #374151;
      margin-bottom: 0.75rem;
    }

    .button-group {
      display: flex;
      flex-wrap: wrap;
      gap: 0.75rem;
    }

    .option-button {
      padding: 0.875rem 1.5rem;
      border: 2px solid #e5e7eb;
      background: white;
      color: #6b7280;
      border-radius: 50px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
      
    }

    .option-button::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, #F7921E 100%, #198754);
      transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      z-index: -1;
    }

    .option-button span {
      position: relative;
      z-index: 1;
    }

    .option-button:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(247, 146, 30, 0.3);
      border-color: #F7921E;
      color: white;
    }

    .option-button:hover::before {
      left: 0;
    }

    .option-button:hover span {
      color: white;
    }

    .option-button.active {
      background: linear-gradient(135deg, #F7921E, #198754);
      border-color: #F7921E;
      color: white;
      box-shadow: 0 8px 25px rgba(247, 146, 30, 0.4);
      transform: translateY(-2px);
    }

    .option-button.active::before {
      left: 0;
    }

    .grid-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
    }

    @media (max-width: 768px) {
      .grid-container {
        grid-template-columns: 1fr;
        gap: 1.5rem;
      }
    }

    .form-input, .form-select {
      width: 100%;
      padding: 0.75rem 1.25rem;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 1rem;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      background: white;
      color: #374151;
      
    }

    .form-input:focus, .form-select:focus {
      outline: none;
      border-color: #F7921E;
      box-shadow: 0 0 0 4px rgba(247, 146, 30, 0.1);
      transform: translateY(-1px);
      background: white;
    }

    .form-input::placeholder {
      color: #9ca3af;
    }
      

    form-select-wrapper {
             position: relative;
        }
        
        /* Custom chevron styling */
        .form-select-wrapper::after {
            content: "";
             position: absolute;
            top: 73%;
            right: 1rem;
            transform: translateY(-50%);
            width: 22px;
            height: 22px;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23374151'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: center;
            pointer-events: none;
            transition: transform 0.3s ease;
        }
        
       

    .checkbox-container {
      display: flex;
      align-items: flex-center;
      gap: 0.75rem;
      margin: 1.5rem 0;
    }

    .checkbox-input {
      width: 40px;
      height: 40px;
      margin-top: 5px;
      padding-top: 5px;
      accent-color: #F7921E;
    }

    .checkbox-label {
      font-size: 0.95rem;
      color: #6b7280;
      line-height: 1.5;
      cursor: pointer;
    }

    .submit-button {
      background: linear-gradient(135deg, #F7921E 100%, #198754 100%);
      color: white;
      padding: 1rem 3rem;
      border: none;
      border-radius: 50px;
      font-size: 1.1rem;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 8px 25px rgba(247, 146, 30, 0.3);
      position: relative;
      overflow: hidden;
    }

    .submit-button::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, #F7921E 100%);
      transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .submit-button span {
      position: relative;
      z-index: 1;
    }

    .submit-button:hover {
      transform: translateY(-3px);
      box-shadow: 0 15px 35px rgba(247, 146, 30, 0.4);
    }

    .submit-button:hover::before {
      left: 0;
    }

    .submit-button:active {
      transform: translateY(-1px);
    }

    .contact-section {
      margin-top: 2.5rem;
      padding-top: 2rem;
      border-top: 1px solid #e5e7eb;
    }
  `;

  return (
    <>
    

      {/* original form */}
   


      {/* new form */}
      <>
        <style>{styles}</style>
        <div className="form-container">
          <div className="form-wrapper">
            <div className="form-card">
              <div className="form-content">
                {/* Personal Profile Section */}
                <div>
                  <h2 className="section-title">Personal Profile</h2>

                  {/* Current Situation */}
                  <div className="form-group">
                    <label className="form-label">What is your current situation?*</label>
                    <div className="button-group">
                      <button
                        type="button"
                        className={`option-button ${studySituation === 'study' ? 'active' : ''}`}
                        onClick={() => handleSituationClick('study')}
                      >
                        <span>I want to study in Canada</span>
                      </button>
                      <button
                        type="button"
                        className={`option-button ${studySituation === 'studying' ? 'active' : ''}`}
                        onClick={() => handleSituationClick('studying')}
                      >
                        <span>I am currently studying in Canada</span>
                      </button>
                    </div>
                  </div>

                  {/* Language and Age Grid */}
                  <div className="grid-container">
                    <div className="form-group">
                      <label className="form-label">What is your preferred language of communication?*</label>
                      <div className="button-group">
                        <button className="option-button" type="button">
                          <span>English</span>
                        </button>
                        <button className="option-button" type="button">
                          <span>French</span>
                        </button>
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Age</label>
                      <input
                        className="form-input"
                        placeholder="Enter Age Here"
                        min={18}
                        max={70}
                        type="number"
                      />
                    </div>
                  </div>

                  {/* Permanent Residence */}
                  <div className="form-group">
                    <label className="form-label">Are you interested in obtaining permanent residence in Canada?*</label>
                    <div className="button-group">
                      <button className="option-button" type="button">
                        <span>Yes</span>
                      </button>
                      <button className="option-button" type="button">
                        <span>No</span>
                      </button>
                    </div>
                  </div>

                  {/* Canadian Studies Section (Conditional) */}
                  {studySituation === 'study' && (
                    <>
                      <div className="form-section">
                        <h2 className="section-title" style={{ marginTop: "15px" }}>Canadian Studies</h2>

                        <div className="form-group">
                          <label className="form-label">Do you have any applications in progress with a Canadian School?</label>
                          <div className="button-group">
                            <button
                              className="option-button"
                              type="button"
                              onClick={() => handleApplicationsClick(true)}
                            >
                              <span>Yes</span>
                            </button>
                            <button
                              className="option-button"
                              type="button"
                              onClick={() => handleApplicationsClick(false)}
                            >
                              <span>No</span>
                            </button>
                          </div>
                        </div>

                        {hasApplications === true && (
                          <div className="form-group">
                            <label className="form-label">With which schools?</label>
                            <input
                              className="form-input"
                              type="text"
                              placeholder="Enter the school name"
                            />
                          </div>
                        )}

                        <div className="form-group">
                          <label className="form-label">Are you working with an existing Recruitment Partner/Agent/Counsellor/Education Consultant?</label>
                          <div className="button-group">
                            <button
                              className="option-button"
                              type="button"
                              onClick={() => handleRecruitmentPartnerClick(true)}
                            >
                              <span>Yes</span>
                            </button>
                            <button
                              className="option-button"
                              type="button"
                              onClick={() => handleRecruitmentPartnerClick(false)}
                            >
                              <span>No</span>
                            </button>
                          </div>
                        </div>

                        {hasRecruitmentPartner === true && (
                          <div className="form-group">
                            <label className="form-label">Who?</label>
                            <input
                              type="text"
                              placeholder="Enter the name"
                              className="form-input"
                            />
                          </div>
                        )}

                        <div className="form-group">
                          <label className="form-label">Do you have a Letter of Acceptance?*</label>
                          <div className="button-group">
                            <button
                              className="option-button"
                              type="button"
                              onClick={() => handleLetterOfAcceptanceClick(true)}
                            >
                              <span>Yes</span>
                            </button>
                            <button
                              className="option-button"
                              type="button"
                              onClick={() => handleLetterOfAcceptanceClick(false)}
                            >
                              <span>No</span>
                            </button>
                          </div>
                        </div>

                        {hasLetterOfAcceptance === true && (
                          <div className="form-group">
                            <label className="form-label">In which Canadian province or territory is the school you will be attending?</label>
                            <select className="form-select">
                              <option value="">Select Province</option>
                              <option value="ON">Ontario</option>
                              <option value="BC">British Columbia</option>
                              <option value="AB">Alberta</option>
                            </select>
                          </div>
                        )}

                        {hasLetterOfAcceptance === false && (
                          <div className="education-form">
                            <div className="section">
                              <label className="form-label">Which provinces do you prefer to study in?</label>
                              <div className="checkbox-group">
                                {["Any Province", "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon"].map((province) => (
                                  <label key={province}>
                                    <input
                                      type="checkbox"
                                      value={province}
                                      checked={selectedProvinces.includes(province)}
                                      onChange={handleProvinceChange}
                                    />
                                    &nbsp;&nbsp;&nbsp; {province}
                                  </label>
                                ))}
                              </div>
                            </div>

                            <div className="form-group">
                              <label className="form-label">What fields of study are you interested in?</label>
                              <select className="form-select">
                                <option value="">Please select</option>
                                <option value="Engineering">Engineering</option>
                                <option value="Medicine">Medicine</option>
                                <option value="Business">Business</option>
                              </select>
                            </div>

                            <div className="form-group">
                              <label className="form-label">What program level are you interested in?</label>
                              <select className="form-select">
                                <option value="">Please select</option>
                                <option value="Undergraduate">Undergraduate</option>
                                <option value="Graduate">Graduate</option>
                              </select>
                            </div>

                            <div className="section">
                              <h3 className="section-title">Your Current Education</h3>

                              <div className="form-group">
                                <label className="form-label">What is your highest level of completed education?</label>
                                <select className="form-select">
                                  <option value="">Please select</option>
                                  <option value="High School">High School</option>
                                  <option value="Bachelor's Degree">Bachelor's Degree</option>
                                </select>
                              </div>

                              <div className="form-group">
                                <label className="form-label">When was your last level of education completed?</label>
                                <div className="grid-container">
                                  <select className="form-select">
                                    <option value="" disabled>Select Month</option>
                                    <option value="january">January</option>
                                    <option value="february">February</option>
                                    <option value="march">March</option>
                                    <option value="april">April</option>
                                    <option value="may">May</option>
                                    <option value="june">June</option>
                                    <option value="july">July</option>
                                    <option value="august">August</option>
                                    <option value="september">September</option>
                                    <option value="october">October</option>
                                    <option value="november">November</option>
                                    <option value="december">December</option>
                                  </select>

                                  <select className="form-select">
                                    <option value="" disabled>Select Year</option>
                                    {Array.from({ length: 25 }, (_, i) => 2000 + i).map(year => (
                                      <option key={year} value={year}>{year}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="form-label">In which country was this level of education obtained?</label>
                                <select className="form-select">
                                  <option value="" disabled>Select country</option>
                                  <option value="united_states">United States</option>
                                  <option value="canada">Canada</option>
                                  <option value="united_kingdom">United Kingdom</option>
                                  <option value="australia">Australia</option>
                                  <option value="germany">Germany</option>
                                  <option value="new_zealand">New Zealand</option>
                                  <option value="france">France</option>
                                  <option value="netherlands">Netherlands</option>
                                  <option value="sweden">Sweden</option>
                                  <option value="ireland">Ireland</option>
                                </select>
                              </div>

                              <div className="form-group">
                                <label className="form-label">Do you have official transcripts from your highest level of completed education?</label>
                                <div className="button-group">
                                  <label className="option-button">
                                    <input type="radio" name="transcripts" value="yes" /> Yes
                                  </label>
                                  <label className="option-button">
                                    <input type="radio" name="transcripts" value="no" /> No
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="grading-system-section">
                              <div className="form-group">
                                <label className="form-label">What was the grading system used by your country?</label>
                                <select
                                  value={selectedGradingSystem}
                                  onChange={handleGradingSystemChange}
                                  className="form-select"
                                >
                                  <option value="">Please select</option>
                                  <option value="0-100">0-100</option>
                                  <option value="0-20">0-20</option>
                                  <option value="0-10">0-10</option>
                                  <option value="0-5">0-5</option>
                                  <option value="0-4">0-4</option>
                                  <option value="division">Division/Class</option>
                                  <option value="letter">A/A+ to F</option>
                                  <option value="other">Other</option>
                                </select>
                              </div>

                              {selectedGradingSystem && (
                                <div className="form-group">
                                  <label className="form-label">GPA</label>
                                  <input
                                    type="text"
                                    value={gpa}
                                    onChange={handleGpaChange}
                                    placeholder="Enter your GPA"
                                    className="form-input"
                                  />
                                </div>
                              )}
                            </div>

                            <div className="section">
                              <h3 className="section-title">Your language skills</h3>

                              <div className="form-group">
                                <label className="form-label">Have you undergone a language proficiency test in English or French?</label>
                                <select
                                  value={selectedLanguage}
                                  onChange={handleLanguageChange}
                                  className="form-select"
                                >
                                  <option value="">Please select</option>
                                  <option value="English">English</option>
                                  <option value="French">French</option>
                                </select>
                              </div>

                              {selectedLanguage && (
                                <div className="language-test-section">
                                  <div className="form-group">
                                    <label className="form-label">Select your test type:</label>
                                    <select
                                      value={selectedTest}
                                      onChange={handleTestChange}
                                      className="form-select"
                                    >
                                      <option value="">Please select</option>
                                      {selectedLanguage === 'English' ? (
                                        <>
                                          <option value="TOEFL">TOEFL</option>
                                          <option value="IELTS Academic">IELTS Academic</option>
                                          <option value="IELTS General">IELTS General</option>
                                          <option value="CELPIP">CELPIP</option>
                                          <option value="CAEL">CAEL</option>
                                          <option value="TEF">TEF</option>
                                        </>
                                      ) : (
                                        <>
                                          <option value="TEF">TEF</option>
                                          <option value="TCF">TCF</option>
                                          <option value="DELF">DELF</option>
                                          <option value="DALF">DALF</option>
                                        </>
                                      )}
                                      <option value="Yes, another test">Yes, another test</option>
                                      <option value="No">No</option>
                                    </select>
                                  </div>

                                  {selectedTest && selectedTest !== 'No' && selectedTest !== 'Yes, another test' && (
                                    <div className="truvz_test-scores">
                                      <div className="grid-container">
                                        <div className="form-group">
                                          <label className="form-label">Listening</label>
                                          <select
                                            className="form-select"
                                            value={scores.listening}
                                            onChange={(e) => handleScoreChange('listening', e.target.value)}
                                          >
                                            <option value="">Please select</option>
                                            {/* Add score options based on test type */}
                                          </select>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">Speaking</label>
                                          <select
                                            className="form-select"
                                            value={scores.speaking}
                                            onChange={(e) => handleScoreChange('speaking', e.target.value)}
                                          >
                                            <option value="">Please select</option>
                                            {/* Add score options based on test type */}
                                          </select>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">Reading</label>
                                          <select
                                            className="form-select"
                                            value={scores.reading}
                                            onChange={(e) => handleScoreChange('reading', e.target.value)}
                                          >
                                            <option value="">Please select</option>
                                            {/* Add score options based on test type */}
                                          </select>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">Writing</label>
                                          <select
                                            className="form-select"
                                            value={scores.writing}
                                            onChange={(e) => handleScoreChange('writing', e.target.value)}
                                          >
                                            <option value="">Please select</option>
                                            {/* Add score options based on test type */}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        <div className="form-group">
                          <label className="form-label">When would you like to start your studies in Canada?</label>
                          <div className="grid-container">
                            <select className="form-select">
                              <option value="" disabled>Select Month</option>
                              <option value="january">January</option>
                              <option value="february">February</option>
                              <option value="march">March</option>
                              <option value="april">April</option>
                              <option value="may">May</option>
                              <option value="june">June</option>
                              <option value="july">July</option>
                              <option value="august">August</option>
                              <option value="september">September</option>
                              <option value="october">October</option>
                              <option value="november">November</option>
                              <option value="december">December</option>
                            </select>

                            <select className="form-select">
                              <option value="" disabled>Select Year</option>
                              {Array.from({ length: 25 }, (_, i) => 2000 + i).map(year => (
                                <option key={year} value={year}>{year}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="form-section">
                        <h2 className="section-title">Financial Support</h2>

                        <div className="form-group">
                          <label className="form-label">What is your estimated budget for tuition per year?</label>
                          <select className="form-select">
                            <option>Please select</option>
                          </select>
                        </div>

                        <div className="form-group">
                          <label className="form-label">
                            Would you have access to at least CAD $35K to cover your tuition fees and living expenses in Canada during your first year of studies?
                          </label>
                          <div className="button-group">
                            <button className="option-button" type="button">Yes</button>
                            <button className="option-button" type="button">No</button>
                          </div>
                        </div>

                        <div className="form-group">
                          <label className="form-label">Have you ever been refused a visa to Canada or any other country?</label>
                          <div className="button-group">
                            <button className="option-button" type="button">Yes</button>
                            <button className="option-button" type="button">No</button>
                          </div>
                        </div>

                        <div className="form-group">
                          <label className="form-label">Do you have a spouse or common-law partner?</label>
                          <div className="button-group">
                            <button className="option-button" type="button">Yes</button>
                            <button className="option-button" type="button">No</button>
                          </div>
                        </div>

                        <div className="form-group">
                          <label className="form-label">Do you have any children?</label>
                          <div className="button-group">
                            <button className="option-button" type="button">Yes</button>
                            <button className="option-button" type="button">No</button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Current Studies Information (Conditional) */}
                  {studySituation === 'studying' && (
                    <>
                      <div className="form-section">
                        <h2 className="section-title">Current Studies Information</h2>

                        <div className="form-group">
                          <label className="form-label">Do you plan on obtaining a Post-Graduation Work Permit upon completion of your studies in Canada?</label>
                          <div className="button-group">
                            <button className="option-button" type="button">Yes</button>
                            <button className="option-button" type="button">No</button>
                          </div>
                        </div>

                        <div className="form-group">
                          <label className="form-label">After completion of your current study program, do you intend to pursue further studies in Canada?</label>
                          <div className="button-group">
                            <button className="option-button" type="button">Yes</button>
                            <button className="option-button" type="button">No</button>
                          </div>
                        </div>

                        <div className="form-group">
                          <label className="form-label">Do you possess a valid Canadian Study Permit?*</label>
                          <div className="button-group">
                            <button
                              className="option-button"
                              type="button"
                              onClick={() => handleStudyPermitClick(true)}
                            >
                              <span>Yes</span>
                            </button>
                            <button
                              className="option-button"
                              type="button"
                              onClick={() => handleStudyPermitClick(false)}
                            >
                              <span>No</span>
                            </button>
                          </div>
                        </div>

                        {hasStudyPermit === true && (
                          <>
                            <div className="form-group">
                              <label className="form-label">When do you expect to complete your current study program in Canada?</label>
                              <div className="grid-container">
                                <select className="form-select">
                                  <option value="" disabled>Month</option>
                                  <option value="01">January</option>
                                  <option value="02">February</option>
                                  <option value="03">March</option>
                                  <option value="04">April</option>
                                  <option value="05">May</option>
                                  <option value="06">June</option>
                                  <option value="07">July</option>
                                  <option value="08">August</option>
                                  <option value="09">September</option>
                                  <option value="10">October</option>
                                  <option value="11">November</option>
                                  <option value="12">December</option>
                                </select>

                                <select className="form-select">
                                  <option value="" disabled>Select Year</option>
                                  {Array.from({ length: 25 }, (_, i) => 2000 + i).map(year => (
                                    <option key={year} value={year}>{year}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="form-group">
                              <label className="form-label">In which Canadian province or territory is the school you are currently attending?</label>
                              <select className="form-select">
                                <option value="">Select Province</option>
                                <option value="AB">Alberta</option>
                                <option value="BC">British Columbia</option>
                                <option value="MB">Manitoba</option>
                                <option value="NB">New Brunswick</option>
                                <option value="NL">Newfoundland and Labrador</option>
                                <option value="NS">Nova Scotia</option>
                                <option value="ON">Ontario</option>
                                <option value="PE">Prince Edward Island</option>
                                <option value="QC">Quebec</option>
                                <option value="SK">Saskatchewan</option>
                                <option value="NT">Northwest Territories</option>
                                <option value="NU">Nunavut</option>
                                <option value="YT">Yukon</option>
                              </select>
                            </div>

                            <div className="form-group">
                              <label className="form-label">What is the name of the institution at which you are currently studying?</label>
                              <input
                                type="text"
                                placeholder="Enter institution name"
                                className="form-input"
                              />
                            </div>

                            <div className="form-group">
                              <label className="form-label">What is the field of study that you are currently enrolled in?</label>
                              <input
                                type="text"
                                placeholder="Enter your field of study"
                                className="form-input"
                              />
                            </div>

                            <div className="form-group">
                              <label className="form-label">What is the level of education you are currently enrolled in (e.g. bachelor/master's/doctoral)?</label>
                              <select className="form-select">
                                <option value="">Please select</option>
                                <option value="bachelor">Bachelor's Degree</option>
                                <option value="master">Master's Degree</option>
                                <option value="doctoral">Doctoral Degree</option>
                                <option value="diploma">Diploma</option>
                                <option value="certificate">Certificate</option>
                              </select>
                            </div>
                          </>
                        )}

                        {hasStudyPermit === false && (
                          <div className="form-group">
                            <label className="form-label">What is your current status in Canada?</label>
                            <select className="form-select">
                              <option value="">Please select</option>
                              <option value="work_permit">Work Permit</option>
                              <option value="visitor">Visitor</option>
                              <option value="permanent_resident">Permanent Resident</option>
                              <option value="citizen">Citizen</option>
                              <option value="out_of_status">Out of Status</option>
                            </select>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>

                {/* Contact Information Section */}
                <div className="contact-section">
                  <h2 className="section-title">Enter Contact Information</h2>

                  <div className="form-group">
                    <label className="form-label">Name*</label>
                    <input
                      type="text"
                      placeholder="Enter your name"
                      className="form-input"
                    />
                  </div>

                  <div className="grid-container">
                    <div className="form-group">
                      <label className="form-label">Country of residence</label>
                      <div class="form-select-wrapper">
                        <select class="form-select">
                          <option value="" disabled selected>Select country</option>
                          <option value="united_states">United States</option>
                          <option value="canada">Canada</option>
                          <option value="united_kingdom">United Kingdom</option>
                          <option value="australia">Australia</option>
                          <option value="germany">Germany</option>
                          <option value="new_zealand">New Zealand</option>
                          <option value="france">France</option>
                          <option value="netherlands">Netherlands</option>
                          <option value="sweden">Sweden</option>
                          <option value="ireland">Ireland</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Email*</label>
                      <input
                        type="email"
                        placeholder="Enter your email address"
                        className="form-input"
                      />
                    </div>


                  </div>

                  <div className="grid-container">
                    <div className="form-group">
                      <label className="form-label">Country of citizenship</label>
                      <div className='form-select-wrapper'>

                        <select className="form-select">
                          <option value="" disabled selected>Select country</option>
                          <option value="united_states">United States</option>
                          <option value="canada">Canada</option>
                          <option value="united_kingdom">United Kingdom</option>
                          <option value="australia">Australia</option>
                          <option value="germany">Germany</option>
                          <option value="new_zealand">New Zealand</option>
                          <option value="france">France</option>
                          <option value="netherlands">Netherlands</option>
                          <option value="sweden">Sweden</option>
                          <option value="ireland">Ireland</option>
                        </select>
                      </div>

                    </div>

                    <div className="form-group">
                      <label className="form-label">Telephone*</label>
                      <input
                        type="tel"
                        placeholder="Enter your phone number, including country "
                        className="form-input"
                      />
                    </div>
                  </div>

                  <div className="form-group2">
                    <input type="checkbox" className="custom-checkbox2" />
                    <label className="custom-label2">Yes, please send me the free Canadian Immigration Newsletter by email.</label>
                  </div>

                  <button type="submit" className="submit-button">
                    <span>Submit Form</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default Student_Form;